import { SvgIcon, SvgIconProps } from "@mui/material";
import { lazy, Suspense, memo } from "react";

interface Props extends SvgIconProps {
  icon: string;
}

const iconModules = import.meta.glob("../../../../theme/icons/*.tsx", {
  eager: false,
});

function IconComponent({ icon, ...props }: Props) {
  const modulePath = `../../../../theme/icons/${icon}.tsx`;
  const importer = iconModules[modulePath];

  if (!importer) {
    throw new Error(`Icon '${icon}' not found at ${modulePath}`);
  }

  const DynamicIcon = lazy(async () => {
    const iconModule: any = await importer();
    return iconModule;
  });

  return (
    <Suspense fallback={<SvgIcon sx={props?.sx} />}>
      <DynamicIcon {...props} />
    </Suspense>
  );
}

const IconLoader = memo(
  IconComponent,
  (prevProps, nextProps) =>
    JSON.stringify(prevProps) === JSON.stringify(nextProps)
);
export default IconLoader;
